import { frontendURL } from '../../../../helper/URLHelper';

const SUPPORT_LLM_FEATURE_FLAG = 'support_llm_assistant';

const support = accountId => ({
  parentNav: 'support',
  routes: [
    'support_diagnostics',
    'support_events',
    'support_webhook_deliveries',
    'support_campaign_errors',
    'support_incidents',
    'support_whatsapp_flow',
    'support_conversation_timeline',
    'support_llm_settings',
    'support_knowledge_assistant',
    'support_knowledge_base',
  ],
  menuItems: [
    {
      icon: 'book-pulse',
      label: 'SUPPORT_DIAGNOSTICS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/support/diagnostics`),
      toStateName: 'support_diagnostics',
    },
    {
      icon: 'search',
      label: 'SUPPORT_LOG_SEARCH',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/support/events`),
      toStateName: 'support_events',
    },
    {
      icon: 'link',
      label: 'SUPPORT_WEBHOOK_DELIVERIES',
      hasSubMenu: false,
      truncateLabel: true,
      toState: frontendURL(`accounts/${accountId}/support/webhook-deliveries`),
      toStateName: 'support_webhook_deliveries',
    },
    {
      icon: 'error-circle',
      label: 'SUPPORT_CAMPAIGN_ERRORS',
      hasSubMenu: false,
      truncateLabel: true,
      toState: frontendURL(`accounts/${accountId}/support/campaign-errors`),
      toStateName: 'support_campaign_errors',
    },
    {
      icon: 'flame',
      label: 'SUPPORT_INCIDENTS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/support/incidents`),
      toStateName: 'support_incidents',
    },
    {
      icon: 'whatsapp',
      label: 'SUPPORT_WHATSAPP_FLOW',
      hasSubMenu: false,
      truncateLabel: true,
      toState: frontendURL(`accounts/${accountId}/support/whatsapp-flow`),
      toStateName: 'support_whatsapp_flow',
    },
    {
      icon: 'book-clock',
      label: 'SUPPORT_CONVERSATION_TIMELINE',
      hasSubMenu: false,
      truncateLabel: true,
      toState: frontendURL(
        `accounts/${accountId}/support/conversation-timeline`
      ),
      toStateName: 'support_conversation_timeline',
    },
    {
      label: 'SUPPORT_ASSISTANT_SECTION',
      hasSubMenu: true,
      featureFlag: SUPPORT_LLM_FEATURE_FLAG,
      toState: frontendURL(`accounts/${accountId}/support/ai-settings`),
      toStateName: 'support_llm_settings',
      children: [
        {
          id: '1',
          icon: 'bot',
          label: 'SUPPORT_AI_ASSISTANT_CONFIG',
          toState: frontendURL(`accounts/${accountId}/support/ai-settings`),
          toStateName: 'support_llm_settings',
          truncateLabel: true,
        },
        {
          id: '2',
          icon: 'chat-help',
          label: 'SUPPORT_ASSISTANT',
          toState: frontendURL(`accounts/${accountId}/support/assistant`),
          toStateName: 'support_knowledge_assistant',
          truncateLabel: true,
        },
        {
          id: '3',
          icon: 'library',
          label: 'SUPPORT_KNOWLEDGE_BASE',
          toState: frontendURL(`accounts/${accountId}/support/knowledge-base`),
          toStateName: 'support_knowledge_base',
          truncateLabel: true,
        },
      ],
    },
  ],
});

export default support;
